@if (this.svgIcon || this.fontIcon) {
    <mat-icon inline [style.color]="color" [fontSet]="matFontSet" [svgIcon]="svgIcon">{{fontIcon}}</mat-icon>
}

@if (this.filePath) {
    <img [src]="this.filePath" alt="" srcset="" class="img">
}
